import { put, call } from 'redux-saga/effects'

import { BFFAgent } from '../../../../common/BFFAgent'
import {
  STOCK_TAKING_CAR_MANAGEMENT_MODELS_DATA_MASTER_SUCCESS,
  STOCK_TAKING_CAR_MANAGEMENT_MODELS_DATA_MASTER_FAILURE
} from '../constants'

export function* getModelsDataMasterSaga({data: { brandId }}) {
  try {

      if(brandId){

        const result =  yield call(BFFAgent.Datamasters.getModels, brandId)
        const modelsList = result?.data?.data
  
        yield put({
            type: STOCK_TAKING_CAR_MANAGEMENT_MODELS_DATA_MASTER_SUCCESS,
            data: modelsList
        })

      } else {

        yield put({
          type: STOCK_TAKING_CAR_MANAGEMENT_MODELS_DATA_MASTER_FAILURE,
          data: { error: 'Se necesita el Id de la marca' }
        })
        
      }
      
  } catch (error) {
    yield put({
      type: STOCK_TAKING_CAR_MANAGEMENT_MODELS_DATA_MASTER_FAILURE,
      data: { error }
    })
  }
}
